module.exports = __webpack_public_path__ + "img/17-top.40d89502.jpg";